import {EmptyState, Skeleton, Spinner, Typography} from '@sollapay/ui/components';

import type {FC} from 'react';

const SKELETON_ROWS = [0, 1];

export const RosterSidebarLoadingList: FC<{label: string}> = ({label}) => (
  <div
    data-slot="roster-sidebar-loading"
    className="overflow-hidden rounded-xl border border-border-subtle bg-background-surface"
  >
    <div className="flex items-center justify-between gap-3 bg-background-surface_hover px-4 py-3">
      <Typography size="xs" weight="medium" className="text-brand-primary">
        {label}
      </Typography>
      <Spinner tone="brand" />
    </div>
    {SKELETON_ROWS.map(row => (
      <div key={row} className="flex flex-col gap-2 border-t border-border-subtle px-4 py-4">
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-2.5 w-20" />
      </div>
    ))}
  </div>
);

export const RosterPaneLoading: FC<{title: string; subtitle: string}> = ({title, subtitle}) => (
  <EmptyState
    size="sm"
    className="flex-1 justify-center"
    showGrid={false}
    title={title}
    subtitle={subtitle}
    illustration={<Spinner size="xl" tone="brand" />}
  />
);
